import { render, staticRenderFns } from "./LiveOrdersView.vue?vue&type=template&id=0cbea2ba&"
import script from "./LiveOrdersView.vue?vue&type=script&lang=js&"
export * from "./LiveOrdersView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports